import { css } from 'emotion'

export const UpdateTaskStatusesFormStyles = css``
